/** Backend: "beds/full" or "beds/full.half" — split on "/" then first "." */

export const MAX_BEDS_FULL_HALF = 99;

export function clampBedsFullHalfInt(value) {
  const n = parseInt(String(value ?? "").replace(/,/g, "").trim() || "0", 10);
  if (Number.isNaN(n)) return 0;
  return Math.min(MAX_BEDS_FULL_HALF, Math.max(0, n));
}

/** @returns {{ beds: number, full: number, half: number }} */
export function parseBedBathsString(input) {
  const out = { beds: 0, full: 0, half: 0 };
  if (input == null || input === "") return out;
  const s = String(input).trim();
  if (!s || s === "null" || s === "-/-") return out;

  const slash = s.indexOf("/");
  if (slash < 0) return out;

  out.beds = clampBedsFullHalfInt(s.slice(0, slash));
  const rest = s.slice(slash + 1).trim();
  if (!rest) return out;

  const dot = rest.indexOf(".");
  if (dot < 0) {
    out.full = clampBedsFullHalfInt(rest);
    return out;
  }
  out.full = clampBedsFullHalfInt(rest.slice(0, dot));
  out.half = clampBedsFullHalfInt(rest.slice(dot + 1));
  return out;
}

export function formatBedBathsString(beds, fullBath, halfBath) {
  const b = clampBedsFullHalfInt(beds);
  const f = clampBedsFullHalfInt(fullBath);
  const h = clampBedsFullHalfInt(halfBath);
  return h === 0 ? `${b}/${f}` : `${b}/${f}.${h}`;
}

export function validateBedsFullHalfForm(data) {
  const out = {};
  const max = MAX_BEDS_FULL_HALF;
  const check = (val, key, label, required) => {
    const raw = val == null ? "" : String(val).trim();
    if (required && raw === "") {
      out[key] = `${label} is required`;
      return;
    }
    if (raw === "") return;
    if (!/^\d+$/.test(raw)) {
      out[key] = `${label} must be a whole number`;
      return;
    }
    if (parseInt(raw, 10) > max) {
      out[key] = `${label} cannot be more than ${max}`;
    }
  };
  check(data.beds, "beds", "Beds", true);
  check(data.fullBath, "fullBath", "Full Bath", true);
  check(data.halfBath, "halfBath", "Half Bath", false);
  return out;
}
